import clsx from 'clsx';

import style from './style.module.scss';

export const FormStructureDivider = (props: ICustomizable) => (
  <div className={clsx(style['form-structure-divider'], props.className)} />
);
